import { createFileRoute, Link } from "@tanstack/react-router";
import { Header } from "@/components/rawan/Header";
import { Footer } from "@/components/rawan/Footer";
import { getAllCategories, filterByCategory } from "@/lib/content/loader";
import { useAllItems } from "@/lib/library-store";
import { useTheme } from "@/lib/theme-context";

export const Route = createFileRoute("/categories/")({
  head: () => ({
    meta: [
      { title: "التصنيفات — Rawan UI" },
      { name: "description", content: "تصفّح المحتوى حسب التصنيف." },
      { property: "og:title", content: "Categories — Rawan UI" },
      { property: "og:url", content: "/categories" },
    ],
    links: [{ rel: "canonical", href: "/categories" }],
  }),
  component: CategoriesPage,
});

function CategoriesPage() {
  const cats = getAllCategories();
  const { language } = useTheme();
  const t = (ar: string, en: string, fr: string) =>
    language === "ar" ? ar : language === "fr" ? fr : en;
  const pick = (c: { ar: string; en: string; fr: string }) =>
    language === "ar" ? c.ar : language === "fr" ? c.fr : c.en;
  const alt = (c: { ar: string; en: string; fr: string }) =>
    language === "ar" ? c.en : language === "fr" ? c.en : c.ar;
  const itemsLabel = t("عنصر", "items", "éléments");

  return (
    <div className="min-h-dvh flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-10">
        <header className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-extrabold">
            {t("التصنيفات", "Categories", "Catégories")}
          </h1>
          <p className="text-muted-foreground mt-1">
            {t(
              "يتم استخراجها تلقائياً من المحتوى.",
              "Automatically extracted from content.",
              "Extraites automatiquement du contenu.",
            )}
          </p>
        </header>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {cats.map((c) => (
            <Link
              key={c.slug}
              to="/categories/$slug"
              params={{ slug: c.slug }}
              className="rounded-2xl border border-border bg-card hover:border-primary p-5 transition"
            >
              <div className="font-extrabold text-lg">{pick(c)}</div>
              <div className="text-xs text-muted-foreground">
                {alt(c)} · {c.count} {itemsLabel}
              </div>
            </Link>
          ))}
          {cats.length === 0 && (
            <p className="text-muted-foreground">
              {t("لا توجد تصنيفات بعد.", "No categories yet.", "Aucune catégorie pour le moment.")}
            </p>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}

// silence "unused" — kept for future personalised category cards
void useAllItems;
void filterByCategory;
